import { Helmet } from 'react-helmet-async';
import { Navigate, Route, Routes } from 'react-router-dom';

import { DashboardLayout } from './components/DashboardLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { DataSourceConfigurationPage } from './pages/DataSourceConfigurationPage';
import { EIRnDTopLevelKPIDashboard } from './pages/EIRnDTopLevelKPIDashboard';
import { LeadershipDashboard } from './pages/LeadershipDashboard';
import { LoginPage } from './pages/LoginPage';
import { MetricsConfigurationPage } from './pages/MetricsConfigurationPage';

function App() {
  return (
    <>
      <Helmet>
        <title>Delivery Metrics Dashboard</title>
        <meta
          name='description'
          content='Software Delivery Metrics Dashboard - Analytics platform for development and delivery performance'
        />
      </Helmet>

      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path='/login' element={<LoginPage />} />

          {/* Protected dashboard routes */}
          <Route
            path='/top-level-kpi'
            element={
              <ProtectedRoute
                requiredRoles={[
                  'Admin',
                  'Leadership',
                  'ScrumMaster',
                  'Developer',
                  'Guest',
                ]}
              >
                <DashboardLayout>
                  <EIRnDTopLevelKPIDashboard />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path='/leadership'
            element={
              <ProtectedRoute requiredRoles={['Leadership']}>
                <DashboardLayout>
                  <LeadershipDashboard />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path='/metrics-configuration'
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <DashboardLayout>
                  <MetricsConfigurationPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          <Route
            path='/data-sources'
            element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <DashboardLayout>
                  <DataSourceConfigurationPage />
                </DashboardLayout>
              </ProtectedRoute>
            }
          />

          {/* Default route - redirect to IE R&D KPI dashboard */}
          <Route
            path='/'
            element={
              <ProtectedRoute>
                <Navigate to='/top-level-kpi' replace />
              </ProtectedRoute>
            }
          />

          {/* Catch all route - redirect to home */}
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default App;
